// extracted by mini-css-extract-plugin
module.exports = {"Switch":"bmS5","Switch__Item":"b_TH"};